export function getDocumentReaderRunResultsUrl(runId: string): string {
  return `${process.env.NEXT_PUBLIC_SERVER_URL}/api/v1/agent-platform/document-reader/runs/${encodeURIComponent(runId)}/results`;
}
